import { useEffect, useState } from 'react';
import usePostCancelHelpRequest from 'Domain/host-help-partner/usePostCancelHelpRequest';
import { Box } from '@chakra-ui/react';

import styles from './styles.module.css';

const ProgressBar = ({ cancelDuration, taskId }) => {
  const totalDuration = 3 * 60;
  const [count, setCount] = useState(cancelDuration);
  const { mutate: onPostCancelHelpRequest } = usePostCancelHelpRequest();

  const percentage = (count / totalDuration) * 100;

  useEffect(() => {
    const timer = setInterval(() => setCount((prev) => prev + 1), 1000);
    return () => clearInterval(timer);
  }, []);

  useEffect(() => {
    if (count >= totalDuration) onPostCancelHelpRequest(taskId);
    /* eslint-disable */
  }, [count, totalDuration, taskId]);

  return (
    <Box className={styles['progress-bar__container']}>
      <Box width={`${percentage}%`} className={`${styles['progress-bar__progress-fill-track']}`} />
    </Box>
  );
};

export default ProgressBar;
